import React from 'react'

import { SidebarConfig } from './useSidebar'
import './sidebar.scss'

export type SidebarTabContentProps = {
  config: SidebarConfig
  children: React.ReactNode
  className?: string
}

export const SidebarTabContent: React.FC<SidebarTabContentProps> = ({ config, children }) => {
  // Only render the active SidebarContent child
  const childArray = React.Children.toArray(children) as Array<React.ReactElement<{ name?: string }>>

  return (
    <section className="tp-sidebar__tab-content">
      {childArray.map(child => {
        if (!React.isValidElement(child)) return null
        const nameProp = child.props?.name as string | undefined
        if (!nameProp) return null
        const ids = config.a11y[nameProp]
        const hidden = config.active !== nameProp
        return React.cloneElement(child, {
          key: nameProp,
          role: 'tabpanel',
          'aria-labelledby': ids?.tabId,
          hidden,
          ...({ id: ids?.panelId } as any)
        })
      })}
    </section>
  )
}

export default SidebarTabContent
